/**
 * AUTO-GENERATED by scripts/generate-landing-demo-slate.ts — do not hand-edit.
 *
 * Featured edges from the real 2026-04-26 NBA slate, as served at the
 * last_projection_update snapshot, with each one's real graded result (bet_results).
 */
import type { BookLine, BestLines, MarketCode } from '@sharpr/types';
import type { LineSnapshot } from '@/lib/lineMovement';

export interface DemoFeaturedEdge {
  key: string;
  playerId: string;
  player: string;
  team: string;
  position?: string;
  imageUrl?: string;
  opponent: string;
  isHome: boolean;
  matchup: string;
  commenceTime: string;
  marketCode: MarketCode;
  marketLabel: string;
  projection: number | null;
  projectedMinutes: number | null;
  side: 'over' | 'under';
  line: number;
  bestBook: string;
  bestOdds: string;
  ev: number;
  evLabel: string;
  pWin?: number;
  books: BookLine[];
  bestLines: BestLines;
  result?: { outcome: string; actual: number };
  /** Fitted PMF for the overlay EV calculator. */
  pmf: number[];
  /** Real movement series; empty when the game kept a single snapshot. */
  movements: LineSnapshot[];
}

/** Featured edges as served, with their real graded result. First = mobile headline. */
export const DEMO_FEATURED: DemoFeaturedEdge[] = [
  {
    "key": "1629028:pra",
    "playerId": "1629028",
    "player": "Deandre Ayton",
    "team": "LAL",
    "position": "C",
    "imageUrl": "https://cdn.nba.com/headshots/nba/latest/1040x760/1629028.png",
    "opponent": "HOU",
    "isHome": false,
    "matchup": "LAL @ HOU",
    "commenceTime": "2026-04-27T01:40:00.000Z",
    "marketCode": "pra",
    "marketLabel": "PRA",
    "projection": 22.86,
    "projectedMinutes": 30,
    "side": "over",
    "line": 20.5,
    "bestBook": "bovada",
    "bestOdds": "-110",
    "ev": 0.1589,
    "evLabel": "+15.9%",
    "pWin": 61,
    "books": [
      {
        "book": "fanduel",
        "side": "over",
        "line": 20.5,
        "odds": -128,
        "isRemoved": false,
        "ev": 0.0813,
        "pWin": 61
      },
      {
        "book": "fanduel",
        "side": "under",
        "line": 20.5,
        "odds": 100,
        "isRemoved": false,
        "ev": -0.2141,
        "pWin": 39
      },
      {
        "book": "thescore",
        "side": "over",
        "line": 20.5,
        "odds": -125,
        "isRemoved": false,
        "ev": 0.0927,
        "pWin": 61
      },
      {
        "book": "thescore",
        "side": "under",
        "line": 20.5,
        "odds": -105,
        "isRemoved": false,
        "ev": -0.2328,
        "pWin": 39
      },
      {
        "book": "fanatics",
        "side": "over",
        "line": 20.5,
        "odds": -115,
        "isRemoved": false,
        "ev": 0.135,
        "pWin": 61
      },
      {
        "book": "fanatics",
        "side": "under",
        "line": 20.5,
        "odds": -115,
        "isRemoved": false,
        "ev": -0.2654,
        "pWin": 39
      },
      {
        "book": "betr_us_dfs",
        "side": "over",
        "line": 20.5,
        "odds": -118,
        "isRemoved": false,
        "ev": 0.1215,
        "pWin": 61
      },
      {
        "book": "betr_us_dfs",
        "side": "under",
        "line": 20.5,
        "odds": -118,
        "isRemoved": false,
        "ev": -0.2741,
        "pWin": 39
      },
      {
        "book": "pick6",
        "side": "over",
        "line": 20.5,
        "odds": -122,
        "isRemoved": false,
        "ev": 0.1047,
        "pWin": 61
      },
      {
        "book": "pick6",
        "side": "under",
        "line": 20.5,
        "odds": -122,
        "isRemoved": false,
        "ev": -0.285,
        "pWin": 39
      },
      {
        "book": "draftkings",
        "side": "over",
        "line": 20.5,
        "odds": -125,
        "isRemoved": false,
        "ev": 0.0927,
        "pWin": 61
      },
      {
        "book": "draftkings",
        "side": "under",
        "line": 20.5,
        "odds": -105,
        "isRemoved": false,
        "ev": -0.2328,
        "pWin": 39
      },
      {
        "book": "fliff",
        "side": "over",
        "line": 20.5,
        "odds": -120,
        "isRemoved": false,
        "ev": 0.113,
        "pWin": 61
      },
      {
        "book": "fliff",
        "side": "under",
        "line": 20.5,
        "odds": -120,
        "isRemoved": false,
        "ev": -0.2796,
        "pWin": 39
      },
      {
        "book": "betmgm",
        "side": "over",
        "line": 20.5,
        "odds": -130,
        "isRemoved": false,
        "ev": 0.074,
        "pWin": 61
      },
      {
        "book": "betmgm",
        "side": "under",
        "line": 20.5,
        "odds": -105,
        "isRemoved": false,
        "ev": -0.2328,
        "pWin": 39
      },
      {
        "book": "bovada",
        "side": "over",
        "line": 20.5,
        "odds": -110,
        "isRemoved": false,
        "ev": 0.1589,
        "pWin": 61
      },
      {
        "book": "bovada",
        "side": "under",
        "line": 20.5,
        "odds": -120,
        "isRemoved": false,
        "ev": -0.2796,
        "pWin": 39
      },
      {
        "book": "prizepicks",
        "side": "over",
        "line": 20.5,
        "odds": -119,
        "isRemoved": false,
        "ev": 0.1172,
        "pWin": 61
      },
      {
        "book": "prizepicks",
        "side": "under",
        "line": 20.5,
        "odds": -119,
        "isRemoved": false,
        "ev": -0.2769,
        "pWin": 39
      },
      {
        "book": "hardrockbet",
        "side": "over",
        "line": 20.5,
        "odds": -125,
        "isRemoved": false,
        "ev": 0.0927,
        "pWin": 61
      },
      {
        "book": "hardrockbet",
        "side": "under",
        "line": 20.5,
        "odds": -105,
        "isRemoved": false,
        "ev": -0.2328,
        "pWin": 39
      },
      {
        "book": "prophetx",
        "side": "over",
        "line": 20.5,
        "odds": -129,
        "isRemoved": false,
        "ev": 0.0777,
        "pWin": 61,
        "betLimit": 112
      },
      {
        "book": "prophetx",
        "side": "under",
        "line": 20.5,
        "odds": -113,
        "isRemoved": false,
        "ev": -0.2593,
        "pWin": 39,
        "betLimit": 106
      },
      {
        "book": "novig",
        "side": "over",
        "line": 20.5,
        "odds": -112,
        "isRemoved": false,
        "ev": 0.1491,
        "pWin": 61,
        "betLimit": 110
      },
      {
        "book": "novig",
        "side": "under",
        "line": 20.5,
        "odds": 105,
        "isRemoved": false,
        "ev": -0.1945,
        "pWin": 39,
        "betLimit": 571
      }
    ],
    "bestLines": {
      "over": {
        "book": "bovada",
        "side": "over",
        "line": 20.5,
        "odds": -110,
        "isRemoved": false,
        "ev": 0.1589,
        "pWin": 61
      },
      "under": {
        "book": "novig",
        "side": "under",
        "line": 20.5,
        "odds": 105,
        "isRemoved": false,
        "ev": -0.1945,
        "pWin": 39,
        "betLimit": 571
      }
    },
    "result": {
      "outcome": "win",
      "actual": 29
    },
    "pmf": [
      0,
      0,
      0,
      0,
      0.0001,
      0.0003,
      0.0008,
      0.0016,
      0.003,
      0.0051,
      0.0081,
      0.0121,
      0.0169,
      0.0226,
      0.0287,
      0.0352,
      0.0415,
      0.0472,
      0.0522,
      0.056,
      0.0585,
      0.0596,
      0.0594,
      0.0579,
      0.0553,
      0.0518,
      0.0478,
      0.0433,
      0.0386,
      0.0339,
      0.0293,
      0.0251,
      0.0212,
      0.0176,
      0.0145,
      0.0119,
      0.0096,
      0.0076,
      0.006,
      0.0047,
      0.0037,
      0.0028,
      0.0022,
      0.0016,
      0.0012,
      0.0009,
      0.0007,
      0.0005,
      0.0004,
      0.0003,
      0.0002,
      0.0001,
      0.0001,
      0.0001,
      0.0001
    ],
    "movements": [
      {
        "id": "demo-1629028-FanDuel-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "fanduel",
        "line": 20.5,
        "over_odds": -128,
        "under_odds": 100,
        "over_ev": 0.0813,
        "under_ev": -0.2141,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-theScore Bet-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "thescore",
        "line": 20.5,
        "over_odds": -125,
        "under_odds": -105,
        "over_ev": 0.0927,
        "under_ev": -0.2328,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-Fanatics-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "fanatics",
        "line": 20.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": 0.135,
        "under_ev": -0.2654,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-Betr Picks-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "betr_us_dfs",
        "line": 20.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": 0.1215,
        "under_ev": -0.2741,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-DraftKings Pick6-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "pick6",
        "line": 20.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": 0.1047,
        "under_ev": -0.285,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-DraftKings-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "draftkings",
        "line": 20.5,
        "over_odds": -125,
        "under_odds": -105,
        "over_ev": 0.0927,
        "under_ev": -0.2328,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-Fliff-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "fliff",
        "line": 20.5,
        "over_odds": -120,
        "under_odds": -120,
        "over_ev": 0.113,
        "under_ev": -0.2796,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-BetMGM-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "betmgm",
        "line": 20.5,
        "over_odds": -130,
        "under_odds": -105,
        "over_ev": 0.074,
        "under_ev": -0.2328,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-Bovada-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "bovada",
        "line": 20.5,
        "over_odds": -110,
        "under_odds": -120,
        "over_ev": 0.1589,
        "under_ev": -0.2796,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-PrizePicks-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "prizepicks",
        "line": 20.5,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": 0.1172,
        "under_ev": -0.2769,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-Hard Rock Bet-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "hardrockbet",
        "line": 20.5,
        "over_odds": -125,
        "under_odds": -105,
        "over_ev": 0.0927,
        "under_ev": -0.2328,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-ProphetX-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "prophetx",
        "line": 20.5,
        "over_odds": -129,
        "under_odds": -113,
        "over_ev": 0.0777,
        "under_ev": -0.2593,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-Novig-0",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "novig",
        "line": 20.5,
        "over_odds": -112,
        "under_odds": 105,
        "over_ev": 0.1491,
        "under_ev": -0.1945,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1629028-DraftKings-1",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "draftkings",
        "line": 21.5,
        "over_odds": -104,
        "under_odds": -127,
        "over_ev": 0.0756,
        "under_ev": -0.1927,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1629028-FanDuel-1",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "fanduel",
        "line": 20.5,
        "over_odds": -120,
        "under_odds": -106,
        "over_ev": 0.113,
        "under_ev": -0.2364,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1629028-BetMGM-1",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "betmgm",
        "line": 20.5,
        "over_odds": -130,
        "under_odds": -105,
        "over_ev": 0.074,
        "under_ev": -0.2328,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1629028-Fliff-1",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "fliff",
        "line": 20.5,
        "over_odds": -125,
        "under_odds": -115,
        "over_ev": 0.0927,
        "under_ev": -0.2654,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1629028-Bovada-1",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "bovada",
        "line": 20.5,
        "over_odds": -110,
        "under_odds": -120,
        "over_ev": 0.1589,
        "under_ev": -0.2796,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1629028-Hard Rock Bet-1",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "hardrockbet",
        "line": 20.5,
        "over_odds": -125,
        "under_odds": -105,
        "over_ev": 0.0927,
        "under_ev": -0.2328,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1629028-PrizePicks-1",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "prizepicks",
        "line": 21,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": 0.0678,
        "under_ev": -0.2181,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1629028-Betr Picks-1",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "betr_us_dfs",
        "line": 20.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": 0.1215,
        "under_ev": -0.2741,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1629028-Novig-1",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "novig",
        "line": 20.5,
        "over_odds": -116,
        "under_odds": 105,
        "over_ev": 0.1304,
        "under_ev": -0.1945,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1629028-DraftKings Pick6-1",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "pick6",
        "line": 21.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": -0.0022,
        "under_ev": -0.1781,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1629028-DraftKings-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "draftkings",
        "line": 20.5,
        "over_odds": -130,
        "under_odds": -101,
        "over_ev": 0.074,
        "under_ev": -0.218,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-FanDuel-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "fanduel",
        "line": 20.5,
        "over_odds": -118,
        "under_odds": -108,
        "over_ev": 0.1215,
        "under_ev": -0.2432,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-BetMGM-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "betmgm",
        "line": 20.5,
        "over_odds": -130,
        "under_odds": -105,
        "over_ev": 0.074,
        "under_ev": -0.2328,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-BetOnline-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "betonlineag",
        "line": 20.5,
        "over_odds": -123,
        "under_odds": -104,
        "over_ev": 0.1006,
        "under_ev": -0.2292,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-theScore Bet-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "thescore",
        "line": 20.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": 0.113,
        "under_ev": -0.2499,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-Fliff-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "fliff",
        "line": 20.5,
        "over_odds": -120,
        "under_odds": -120,
        "over_ev": 0.113,
        "under_ev": -0.2796,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-Bovada-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "bovada",
        "line": 21.5,
        "over_odds": -105,
        "under_odds": -125,
        "over_ev": 0.0705,
        "under_ev": -0.187,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-Hard Rock Bet-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "hardrockbet",
        "line": 20.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": 0.113,
        "under_ev": -0.2499,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-ProphetX-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "prophetx",
        "line": 20.5,
        "over_odds": -115,
        "under_odds": -113,
        "over_ev": 0.135,
        "under_ev": -0.2593,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-Fanatics-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "fanatics",
        "line": 20.5,
        "over_odds": -125,
        "under_odds": -105,
        "over_ev": 0.0927,
        "under_ev": -0.2328,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-PrizePicks-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "prizepicks",
        "line": 21,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": 0.0678,
        "under_ev": -0.2181,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-Betr Picks-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "betr_us_dfs",
        "line": 20.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": 0.1215,
        "under_ev": -0.2741,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1629028-Novig-2",
        "game_id": "demo-399d2e69",
        "player_name": "Deandre Ayton",
        "market": "pra",
        "bookmaker": "novig",
        "line": 20.5,
        "over_odds": -111,
        "under_odds": 105,
        "over_ev": 0.154,
        "under_ev": -0.1945,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      }
    ]
  },
  {
    "key": "2544:ast",
    "playerId": "2544",
    "player": "LeBron James",
    "team": "LAL",
    "position": "F",
    "imageUrl": "https://cdn.nba.com/headshots/nba/latest/1040x760/2544.png",
    "opponent": "HOU",
    "isHome": false,
    "matchup": "LAL @ HOU",
    "commenceTime": "2026-04-27T01:40:00.000Z",
    "marketCode": "ast",
    "marketLabel": "AST",
    "projection": 8.69,
    "projectedMinutes": 38,
    "side": "under",
    "line": 9.5,
    "bestBook": "betmgm",
    "bestOdds": "-125",
    "ev": 0.1246,
    "evLabel": "+12.5%",
    "pWin": 62,
    "books": [
      {
        "book": "underdog",
        "side": "over",
        "line": 8.5,
        "odds": -115,
        "isRemoved": false,
        "ev": -0.0773,
        "pWin": 49
      },
      {
        "book": "underdog",
        "side": "under",
        "line": 8.5,
        "odds": -115,
        "isRemoved": false,
        "ev": -0.0532,
        "pWin": 51
      },
      {
        "book": "pick6",
        "side": "over",
        "line": 8.5,
        "odds": -122,
        "isRemoved": false,
        "ev": -0.1019,
        "pWin": 49
      },
      {
        "book": "pick6",
        "side": "under",
        "line": 8.5,
        "odds": -122,
        "isRemoved": false,
        "ev": -0.0784,
        "pWin": 51
      },
      {
        "book": "prophetx",
        "side": "over",
        "line": 8.5,
        "odds": -126,
        "isRemoved": false,
        "ev": -0.1147,
        "pWin": 49,
        "betLimit": 63
      },
      {
        "book": "prophetx",
        "side": "under",
        "line": 8.5,
        "odds": -104,
        "isRemoved": false,
        "ev": -0.0066,
        "pWin": 51,
        "betLimit": 101
      },
      {
        "book": "fanduel",
        "side": "over",
        "line": 8.5,
        "odds": -122,
        "isRemoved": false,
        "ev": -0.1019,
        "pWin": 49
      },
      {
        "book": "fanduel",
        "side": "under",
        "line": 8.5,
        "odds": -104,
        "isRemoved": false,
        "ev": -0.0066,
        "pWin": 51
      },
      {
        "book": "caesars",
        "side": "over",
        "line": 8.5,
        "odds": -127,
        "isRemoved": false,
        "ev": -0.1178,
        "pWin": 49
      },
      {
        "book": "caesars",
        "side": "under",
        "line": 8.5,
        "odds": -105,
        "isRemoved": false,
        "ev": -0.0112,
        "pWin": 51
      },
      {
        "book": "betr_us_dfs",
        "side": "over",
        "line": 8.5,
        "odds": -118,
        "isRemoved": false,
        "ev": -0.0882,
        "pWin": 49
      },
      {
        "book": "betr_us_dfs",
        "side": "under",
        "line": 8.5,
        "odds": -118,
        "isRemoved": false,
        "ev": -0.0643,
        "pWin": 51
      },
      {
        "book": "bovada",
        "side": "over",
        "line": 8.5,
        "odds": 100,
        "isRemoved": false,
        "ev": -0.0129,
        "pWin": 49
      },
      {
        "book": "bovada",
        "side": "under",
        "line": 8.5,
        "odds": -130,
        "isRemoved": false,
        "ev": -0.104,
        "pWin": 51
      },
      {
        "book": "novig",
        "side": "over",
        "line": 8.5,
        "odds": -113,
        "isRemoved": false,
        "ev": -0.0697,
        "pWin": 49,
        "betLimit": 503
      },
      {
        "book": "novig",
        "side": "under",
        "line": 8.5,
        "odds": 102,
        "isRemoved": false,
        "ev": 0.023,
        "pWin": 51,
        "betLimit": 496
      },
      {
        "book": "hardrockbet",
        "side": "over",
        "line": 8.5,
        "odds": -125,
        "isRemoved": false,
        "ev": -0.1116,
        "pWin": 49
      },
      {
        "book": "hardrockbet",
        "side": "under",
        "line": 8.5,
        "odds": -105,
        "isRemoved": false,
        "ev": -0.0112,
        "pWin": 51
      },
      {
        "book": "thescore",
        "side": "over",
        "line": 8.5,
        "odds": -125,
        "isRemoved": false,
        "ev": -0.1116,
        "pWin": 49
      },
      {
        "book": "thescore",
        "side": "under",
        "line": 8.5,
        "odds": -105,
        "isRemoved": false,
        "ev": -0.0112,
        "pWin": 51
      },
      {
        "book": "prizepicks",
        "side": "over",
        "line": 8.5,
        "odds": -119,
        "isRemoved": false,
        "ev": -0.0917,
        "pWin": 49
      },
      {
        "book": "prizepicks",
        "side": "under",
        "line": 8.5,
        "odds": -119,
        "isRemoved": false,
        "ev": -0.068,
        "pWin": 51
      },
      {
        "book": "betparx",
        "side": "over",
        "line": 8.5,
        "odds": -122,
        "isRemoved": false,
        "ev": -0.1019,
        "pWin": 49
      },
      {
        "book": "betparx",
        "side": "under",
        "line": 8.5,
        "odds": -108,
        "isRemoved": false,
        "ev": -0.0246,
        "pWin": 51
      },
      {
        "book": "draftkings",
        "side": "over",
        "line": 8.5,
        "odds": -116,
        "isRemoved": false,
        "ev": -0.081,
        "pWin": 49
      },
      {
        "book": "draftkings",
        "side": "under",
        "line": 8.5,
        "odds": -113,
        "isRemoved": false,
        "ev": -0.0454,
        "pWin": 51
      },
      {
        "book": "betrivers",
        "side": "over",
        "line": 8.5,
        "odds": -124,
        "isRemoved": false,
        "ev": -0.1084,
        "pWin": 49
      },
      {
        "book": "betrivers",
        "side": "under",
        "line": 8.5,
        "odds": -110,
        "isRemoved": false,
        "ev": -0.0331,
        "pWin": 51
      },
      {
        "book": "betmgm",
        "side": "over",
        "line": 9.5,
        "odds": -105,
        "isRemoved": false,
        "ev": -0.2674,
        "pWin": 38
      },
      {
        "book": "betmgm",
        "side": "under",
        "line": 9.5,
        "odds": -125,
        "isRemoved": false,
        "ev": 0.1246,
        "pWin": 62
      },
      {
        "book": "fliff",
        "side": "over",
        "line": 8.5,
        "odds": -130,
        "isRemoved": false,
        "ev": -0.1268,
        "pWin": 49
      },
      {
        "book": "fliff",
        "side": "under",
        "line": 8.5,
        "odds": -115,
        "isRemoved": false,
        "ev": -0.0532,
        "pWin": 51
      }
    ],
    "bestLines": {
      "over": {
        "book": "bovada",
        "side": "over",
        "line": 8.5,
        "odds": 100,
        "isRemoved": false,
        "ev": -0.0129,
        "pWin": 49
      },
      "under": {
        "book": "betmgm",
        "side": "under",
        "line": 9.5,
        "odds": -125,
        "isRemoved": false,
        "ev": 0.1246,
        "pWin": 62
      }
    },
    "result": {
      "outcome": "win",
      "actual": 9
    },
    "pmf": [
      0.0005,
      0.0035,
      0.0119,
      0.028,
      0.0513,
      0.0776,
      0.101,
      0.116,
      0.1202,
      0.1138,
      0.0998,
      0.0817,
      0.0629,
      0.0459,
      0.0319,
      0.0212,
      0.0135,
      0.0083,
      0.0049,
      0.0028,
      0.0016,
      0.0009,
      0.0005,
      0.0002,
      0.0001,
      0.0001
    ],
    "movements": [
      {
        "id": "demo-2544-Underdog-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "underdog",
        "line": 8.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.0773,
        "under_ev": -0.0532,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-DraftKings Pick6-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "pick6",
        "line": 8.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": -0.1019,
        "under_ev": -0.0784,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-ProphetX-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "prophetx",
        "line": 8.5,
        "over_odds": -126,
        "under_odds": -104,
        "over_ev": -0.1147,
        "under_ev": -0.0066,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-FanDuel-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "fanduel",
        "line": 8.5,
        "over_odds": -122,
        "under_odds": -104,
        "over_ev": -0.1019,
        "under_ev": -0.0066,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-Caesars-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "caesars",
        "line": 8.5,
        "over_odds": -127,
        "under_odds": -105,
        "over_ev": -0.1178,
        "under_ev": -0.0112,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-Betr Picks-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betr_us_dfs",
        "line": 8.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": -0.0882,
        "under_ev": -0.0643,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-Bovada-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "bovada",
        "line": 8.5,
        "over_odds": 100,
        "under_odds": -130,
        "over_ev": -0.0129,
        "under_ev": -0.104,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-Novig-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "novig",
        "line": 8.5,
        "over_odds": -113,
        "under_odds": 102,
        "over_ev": -0.0697,
        "under_ev": 0.023,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-Hard Rock Bet-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "hardrockbet",
        "line": 8.5,
        "over_odds": -125,
        "under_odds": -105,
        "over_ev": -0.1116,
        "under_ev": -0.0112,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-theScore Bet-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "thescore",
        "line": 8.5,
        "over_odds": -125,
        "under_odds": -105,
        "over_ev": -0.1116,
        "under_ev": -0.0112,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-PrizePicks-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "prizepicks",
        "line": 8.5,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": -0.0917,
        "under_ev": -0.068,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-betPARX-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betparx",
        "line": 8.5,
        "over_odds": -122,
        "under_odds": -108,
        "over_ev": -0.1019,
        "under_ev": -0.0246,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-DraftKings-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "draftkings",
        "line": 8.5,
        "over_odds": -116,
        "under_odds": -113,
        "over_ev": -0.081,
        "under_ev": -0.0454,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-BetRivers-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betrivers",
        "line": 8.5,
        "over_odds": -124,
        "under_odds": -110,
        "over_ev": -0.1084,
        "under_ev": -0.0331,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-BetMGM-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betmgm",
        "line": 9.5,
        "over_odds": -105,
        "under_odds": -125,
        "over_ev": -0.2674,
        "under_ev": 0.1246,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-Fliff-0",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "fliff",
        "line": 8.5,
        "over_odds": -130,
        "under_odds": -115,
        "over_ev": -0.1268,
        "under_ev": -0.0532,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-2544-DraftKings-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "draftkings",
        "line": 8.5,
        "over_odds": -121,
        "under_odds": -109,
        "over_ev": -0.0986,
        "under_ev": -0.0289,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-FanDuel-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "fanduel",
        "line": 8.5,
        "over_odds": -122,
        "under_odds": -104,
        "over_ev": -0.1019,
        "under_ev": -0.0066,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-betPARX-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betparx",
        "line": 8.5,
        "over_odds": -121,
        "under_odds": -110,
        "over_ev": -0.0986,
        "under_ev": -0.0331,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-BetRivers-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betrivers",
        "line": 8.5,
        "over_odds": -121,
        "under_odds": -113,
        "over_ev": -0.0986,
        "under_ev": -0.0454,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-BetMGM-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betmgm",
        "line": 9.5,
        "over_odds": 110,
        "under_odds": -150,
        "over_ev": -0.212,
        "under_ev": 0.0413,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-Caesars-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "caesars",
        "line": 8.5,
        "over_odds": -122,
        "under_odds": -109,
        "over_ev": -0.1019,
        "under_ev": -0.0289,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-Fliff-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "fliff",
        "line": 8.5,
        "over_odds": -125,
        "under_odds": -115,
        "over_ev": -0.1116,
        "under_ev": -0.0532,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-Bovada-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "bovada",
        "line": 8.5,
        "over_odds": 100,
        "under_odds": -130,
        "over_ev": -0.0129,
        "under_ev": -0.104,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-Hard Rock Bet-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "hardrockbet",
        "line": 8.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": -0.0952,
        "under_ev": -0.0331,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-ProphetX-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "prophetx",
        "line": 8.5,
        "over_odds": -126,
        "under_odds": -129,
        "over_ev": -0.1147,
        "under_ev": -0.1009,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-PrizePicks-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "prizepicks",
        "line": 8.5,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": -0.0917,
        "under_ev": -0.068,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-Betr Picks-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betr_us_dfs",
        "line": 8.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": -0.0882,
        "under_ev": -0.0643,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-Underdog-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "underdog",
        "line": 8.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.0773,
        "under_ev": -0.0532,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-Novig-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "novig",
        "line": 8.5,
        "over_odds": -113,
        "under_odds": 102,
        "over_ev": -0.0697,
        "under_ev": 0.023,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-DraftKings Pick6-1",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "pick6",
        "line": 8.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": -0.1019,
        "under_ev": -0.0784,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-2544-DraftKings-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "draftkings",
        "line": 8.5,
        "over_odds": -126,
        "under_odds": -104,
        "over_ev": -0.1147,
        "under_ev": -0.0066,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-FanDuel-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "fanduel",
        "line": 8.5,
        "over_odds": -122,
        "under_odds": -104,
        "over_ev": -0.1019,
        "under_ev": -0.0066,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-betPARX-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betparx",
        "line": 8.5,
        "over_odds": -121,
        "under_odds": -109,
        "over_ev": -0.0986,
        "under_ev": -0.0289,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-BetRivers-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betrivers",
        "line": 8.5,
        "over_odds": -122,
        "under_odds": -112,
        "over_ev": -0.1019,
        "under_ev": -0.0414,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-BetMGM-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betmgm",
        "line": 9.5,
        "over_odds": 105,
        "under_odds": -145,
        "over_ev": -0.2308,
        "under_ev": 0.0557,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-Caesars-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "caesars",
        "line": 8.5,
        "over_odds": -122,
        "under_odds": -109,
        "over_ev": -0.1019,
        "under_ev": -0.0289,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-BetOnline-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betonlineag",
        "line": 8.5,
        "over_odds": -125,
        "under_odds": -103,
        "over_ev": -0.1116,
        "under_ev": -0.0018,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-theScore Bet-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "thescore",
        "line": 8.5,
        "over_odds": -125,
        "under_odds": -105,
        "over_ev": -0.1116,
        "under_ev": -0.0112,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-Fliff-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "fliff",
        "line": 8.5,
        "over_odds": -130,
        "under_odds": -115,
        "over_ev": -0.1268,
        "under_ev": -0.0532,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-Bovada-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "bovada",
        "line": 8.5,
        "over_odds": -125,
        "under_odds": -105,
        "over_ev": -0.1116,
        "under_ev": -0.0112,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-Hard Rock Bet-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "hardrockbet",
        "line": 8.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": -0.0952,
        "under_ev": -0.0331,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-ProphetX-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "prophetx",
        "line": 8.5,
        "over_odds": -124,
        "under_odds": -115,
        "over_ev": -0.1084,
        "under_ev": -0.0532,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-PrizePicks-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "prizepicks",
        "line": 8.5,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": -0.0917,
        "under_ev": -0.068,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-Betr Picks-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "betr_us_dfs",
        "line": 8.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": -0.0882,
        "under_ev": -0.0643,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-Underdog-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "underdog",
        "line": 8.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.0773,
        "under_ev": -0.0532,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-Novig-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "novig",
        "line": 8.5,
        "over_odds": -113,
        "under_odds": 102,
        "over_ev": -0.0697,
        "under_ev": 0.023,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-2544-DraftKings Pick6-2",
        "game_id": "demo-399d2e69",
        "player_name": "LeBron James",
        "market": "ast",
        "bookmaker": "pick6",
        "line": 8.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": -0.1019,
        "under_ev": -0.0784,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      }
    ]
  },
  {
    "key": "202331:pts",
    "playerId": "202331",
    "player": "Paul George",
    "team": "PHI",
    "position": "F",
    "imageUrl": "https://cdn.nba.com/headshots/nba/latest/1040x760/202331.png",
    "opponent": "BOS",
    "isHome": true,
    "matchup": "BOS @ PHI",
    "commenceTime": "2026-04-26T23:10:00.000Z",
    "marketCode": "pts",
    "marketLabel": "PTS",
    "projection": 17.02,
    "projectedMinutes": 37,
    "side": "under",
    "line": 18.5,
    "bestBook": "prophetx",
    "bestOdds": "-128",
    "ev": 0.1255,
    "evLabel": "+12.6%",
    "pWin": 63,
    "books": [
      {
        "book": "draftkings",
        "side": "over",
        "line": 16.5,
        "odds": -105,
        "isRemoved": false,
        "ev": -0.0165,
        "pWin": 50
      },
      {
        "book": "draftkings",
        "side": "under",
        "line": 16.5,
        "odds": -121,
        "isRemoved": false,
        "ev": -0.0937,
        "pWin": 50
      },
      {
        "book": "betmgm",
        "side": "over",
        "line": 15.5,
        "odds": -130,
        "isRemoved": false,
        "ev": 0.0181,
        "pWin": 58
      },
      {
        "book": "betmgm",
        "side": "under",
        "line": 15.5,
        "odds": -105,
        "isRemoved": false,
        "ev": -0.1711,
        "pWin": 42
      },
      {
        "book": "caesars",
        "side": "over",
        "line": 16.5,
        "odds": -117,
        "isRemoved": false,
        "ev": -0.0657,
        "pWin": 50
      },
      {
        "book": "caesars",
        "side": "under",
        "line": 16.5,
        "odds": -114,
        "isRemoved": false,
        "ev": -0.0685,
        "pWin": 50
      },
      {
        "book": "prophetx",
        "side": "over",
        "line": 18.5,
        "odds": 126,
        "isRemoved": false,
        "ev": -0.168,
        "pWin": 37,
        "betLimit": 82
      },
      {
        "book": "prophetx",
        "side": "under",
        "line": 18.5,
        "odds": -128,
        "isRemoved": false,
        "ev": 0.1255,
        "pWin": 63,
        "betLimit": 0
      },
      {
        "book": "novig",
        "side": "over",
        "line": 16.5,
        "odds": -112,
        "isRemoved": false,
        "ev": -0.0464,
        "pWin": 50,
        "betLimit": 343
      },
      {
        "book": "novig",
        "side": "under",
        "line": 16.5,
        "odds": -112,
        "isRemoved": false,
        "ev": -0.0607,
        "pWin": 50,
        "betLimit": 343
      },
      {
        "book": "bovada",
        "side": "over",
        "line": 16.5,
        "odds": -120,
        "isRemoved": false,
        "ev": -0.0764,
        "pWin": 50
      },
      {
        "book": "bovada",
        "side": "under",
        "line": 16.5,
        "odds": -110,
        "isRemoved": false,
        "ev": -0.0526,
        "pWin": 50
      },
      {
        "book": "hardrockbet",
        "side": "over",
        "line": 16.5,
        "odds": -120,
        "isRemoved": false,
        "ev": -0.0764,
        "pWin": 50
      },
      {
        "book": "hardrockbet",
        "side": "under",
        "line": 16.5,
        "odds": -110,
        "isRemoved": false,
        "ev": -0.0526,
        "pWin": 50
      },
      {
        "book": "prizepicks",
        "side": "over",
        "line": 17,
        "odds": -119,
        "isRemoved": false,
        "ev": -0.1315,
        "pWin": 43
      },
      {
        "book": "prizepicks",
        "side": "under",
        "line": 17,
        "odds": -119,
        "isRemoved": false,
        "ev": -0.017,
        "pWin": 50
      },
      {
        "book": "fanduel",
        "side": "over",
        "line": 16.5,
        "odds": -120,
        "isRemoved": false,
        "ev": -0.0764,
        "pWin": 50
      },
      {
        "book": "fanduel",
        "side": "under",
        "line": 16.5,
        "odds": -106,
        "isRemoved": false,
        "ev": -0.0356,
        "pWin": 50
      },
      {
        "book": "betr_us_dfs",
        "side": "over",
        "line": 16.5,
        "odds": -118,
        "isRemoved": false,
        "ev": -0.0693,
        "pWin": 50
      },
      {
        "book": "betr_us_dfs",
        "side": "under",
        "line": 16.5,
        "odds": -118,
        "isRemoved": false,
        "ev": -0.0832,
        "pWin": 50
      },
      {
        "book": "pick6",
        "side": "over",
        "line": 16.5,
        "odds": -122,
        "isRemoved": false,
        "ev": -0.0833,
        "pWin": 50
      },
      {
        "book": "pick6",
        "side": "under",
        "line": 16.5,
        "odds": -122,
        "isRemoved": false,
        "ev": -0.097,
        "pWin": 50
      }
    ],
    "bestLines": {
      "over": {
        "book": "betmgm",
        "side": "over",
        "line": 15.5,
        "odds": -130,
        "isRemoved": false,
        "ev": 0.0181,
        "pWin": 58
      },
      "under": {
        "book": "prophetx",
        "side": "under",
        "line": 18.5,
        "odds": -128,
        "isRemoved": false,
        "ev": 0.1255,
        "pWin": 63,
        "betLimit": 0
      }
    },
    "result": {
      "outcome": "win",
      "actual": 16
    },
    "pmf": [
      0,
      0,
      0.0002,
      0.0006,
      0.0016,
      0.0036,
      0.007,
      0.0122,
      0.0191,
      0.0277,
      0.0373,
      0.0472,
      0.0564,
      0.0642,
      0.0699,
      0.073,
      0.0736,
      0.0717,
      0.0678,
      0.0623,
      0.0557,
      0.0487,
      0.0416,
      0.0347,
      0.0285,
      0.0229,
      0.0181,
      0.0141,
      0.0108,
      0.0081,
      0.0061,
      0.0045,
      0.0032,
      0.0023,
      0.0016,
      0.0012,
      0.0008,
      0.0005,
      0.0004,
      0.0003,
      0.0002,
      0.0001,
      0.0001
    ],
    "movements": [
      {
        "id": "demo-202331-DraftKings-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "draftkings",
        "line": 16.5,
        "over_odds": -105,
        "under_odds": -121,
        "over_ev": -0.0165,
        "under_ev": -0.0937,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-BetMGM-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "betmgm",
        "line": 15.5,
        "over_odds": -130,
        "under_odds": -105,
        "over_ev": 0.0181,
        "under_ev": -0.1711,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-Caesars-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "caesars",
        "line": 16.5,
        "over_odds": -117,
        "under_odds": -114,
        "over_ev": -0.0657,
        "under_ev": -0.0685,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-ProphetX-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "prophetx",
        "line": 18.5,
        "over_odds": 126,
        "under_odds": -128,
        "over_ev": -0.168,
        "under_ev": 0.1255,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-Novig-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "novig",
        "line": 16.5,
        "over_odds": -112,
        "under_odds": -112,
        "over_ev": -0.0464,
        "under_ev": -0.0607,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-Bovada-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "bovada",
        "line": 16.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": -0.0764,
        "under_ev": -0.0526,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-Hard Rock Bet-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "hardrockbet",
        "line": 16.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": -0.0764,
        "under_ev": -0.0526,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-PrizePicks-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "prizepicks",
        "line": 17,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": -0.1315,
        "under_ev": -0.017,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-FanDuel-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "fanduel",
        "line": 16.5,
        "over_odds": -120,
        "under_odds": -106,
        "over_ev": -0.0764,
        "under_ev": -0.0356,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-Betr Picks-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "betr_us_dfs",
        "line": 16.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": -0.0693,
        "under_ev": -0.0832,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-DraftKings Pick6-0",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "pick6",
        "line": 16.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": -0.0833,
        "under_ev": -0.097,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:33:34.701Z"
      },
      {
        "id": "demo-202331-FanDuel-1",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "fanduel",
        "line": 16.5,
        "over_odds": -120,
        "under_odds": -106,
        "over_ev": -0.0764,
        "under_ev": -0.0356,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:35:10.254Z"
      },
      {
        "id": "demo-202331-BetMGM-1",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "betmgm",
        "line": 15.5,
        "over_odds": -130,
        "under_odds": -105,
        "over_ev": 0.0181,
        "under_ev": -0.1711,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:35:10.254Z"
      },
      {
        "id": "demo-202331-DraftKings-1",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "draftkings",
        "line": 16.5,
        "over_odds": -105,
        "under_odds": -121,
        "over_ev": -0.0165,
        "under_ev": -0.0937,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:35:10.254Z"
      },
      {
        "id": "demo-202331-Caesars-1",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "caesars",
        "line": 16.5,
        "over_odds": -117,
        "under_odds": -114,
        "over_ev": -0.0657,
        "under_ev": -0.0685,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:35:10.254Z"
      },
      {
        "id": "demo-202331-PrizePicks-1",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "prizepicks",
        "line": 17,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": -0.1315,
        "under_ev": -0.017,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:35:10.254Z"
      },
      {
        "id": "demo-202331-Bovada-1",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "bovada",
        "line": 16.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": -0.0764,
        "under_ev": -0.0526,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:35:10.254Z"
      },
      {
        "id": "demo-202331-Hard Rock Bet-1",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "hardrockbet",
        "line": 16.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": -0.0764,
        "under_ev": -0.0526,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:35:10.254Z"
      },
      {
        "id": "demo-202331-ProphetX-1",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "prophetx",
        "line": 18.5,
        "over_odds": 126,
        "under_odds": -128,
        "over_ev": -0.168,
        "under_ev": 0.1255,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:35:10.254Z"
      },
      {
        "id": "demo-202331-Novig-1",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "novig",
        "line": 16.5,
        "over_odds": -112,
        "under_odds": -112,
        "over_ev": -0.0464,
        "under_ev": -0.0607,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:35:10.254Z"
      },
      {
        "id": "demo-202331-DraftKings Pick6-1",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "pick6",
        "line": 16.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": -0.0833,
        "under_ev": -0.097,
        "has_moved": false,
        "snapshot_at": "2026-04-26T22:35:10.254Z"
      },
      {
        "id": "demo-202331-FanDuel-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "fanduel",
        "line": 16.5,
        "over_odds": -111,
        "under_odds": -115,
        "over_ev": -0.0424,
        "under_ev": -0.0723,
        "has_moved": true,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-BetMGM-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "betmgm",
        "line": 16.5,
        "over_odds": -105,
        "under_odds": -125,
        "over_ev": -0.0165,
        "under_ev": -0.1068,
        "has_moved": true,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-betPARX-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "betparx",
        "line": 16.5,
        "over_odds": -122,
        "under_odds": -108,
        "over_ev": -0.0833,
        "under_ev": -0.0443,
        "has_moved": false,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-BetRivers-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "betrivers",
        "line": 16.5,
        "over_odds": -124,
        "under_odds": -110,
        "over_ev": -0.09,
        "under_ev": -0.0526,
        "has_moved": false,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-DraftKings-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "draftkings",
        "line": 16.5,
        "over_odds": -105,
        "under_odds": -121,
        "over_ev": -0.0165,
        "under_ev": -0.0937,
        "has_moved": false,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-Caesars-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "caesars",
        "line": 16.5,
        "over_odds": -112,
        "under_odds": -120,
        "over_ev": -0.0464,
        "under_ev": -0.0902,
        "has_moved": true,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-BetOnline-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "betonlineag",
        "line": 16.5,
        "over_odds": -108,
        "under_odds": -120,
        "over_ev": -0.0298,
        "under_ev": -0.0902,
        "has_moved": false,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-Fliff-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "fliff",
        "line": 16.5,
        "over_odds": -120,
        "under_odds": -120,
        "over_ev": -0.0764,
        "under_ev": -0.0902,
        "has_moved": false,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-theScore Bet-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "thescore",
        "line": 16.5,
        "over_odds": -105,
        "under_odds": -125,
        "over_ev": -0.0165,
        "under_ev": -0.1068,
        "has_moved": false,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-PrizePicks-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "prizepicks",
        "line": 16.5,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": -0.0729,
        "under_ev": -0.0868,
        "has_moved": true,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-Bovada-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "bovada",
        "line": 16.5,
        "over_odds": -105,
        "under_odds": -125,
        "over_ev": -0.0165,
        "under_ev": -0.1068,
        "has_moved": true,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-Hard Rock Bet-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "hardrockbet",
        "line": 16.5,
        "over_odds": -110,
        "under_odds": -120,
        "over_ev": -0.0383,
        "under_ev": -0.0902,
        "has_moved": true,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-Betr Picks-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "betr_us_dfs",
        "line": 16.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": -0.0693,
        "under_ev": -0.0832,
        "has_moved": false,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-ProphetX-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "prophetx",
        "line": 16.5,
        "over_odds": 110,
        "under_odds": -116,
        "over_ev": 0.0579,
        "under_ev": -0.076,
        "has_moved": true,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-Underdog-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "underdog",
        "line": 16.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.0582,
        "under_ev": -0.0723,
        "has_moved": false,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-Novig-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "novig",
        "line": 16.5,
        "over_odds": 109,
        "under_odds": -111,
        "over_ev": 0.0529,
        "under_ev": -0.0567,
        "has_moved": true,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      },
      {
        "id": "demo-202331-DraftKings Pick6-2",
        "game_id": "demo-62dc6619",
        "player_name": "Paul George",
        "market": "pts",
        "bookmaker": "pick6",
        "line": 16.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": -0.0833,
        "under_ev": -0.097,
        "has_moved": false,
        "snapshot_at": "2026-04-26T23:01:10.630Z"
      }
    ]
  },
  {
    "key": "1631095:3pm",
    "playerId": "1631095",
    "player": "Jabari Smith Jr",
    "team": "HOU",
    "position": "F",
    "imageUrl": "https://cdn.nba.com/headshots/nba/latest/1040x760/1631095.png",
    "opponent": "LAL",
    "isHome": true,
    "matchup": "LAL @ HOU",
    "commenceTime": "2026-04-27T01:40:00.000Z",
    "marketCode": "3pm",
    "marketLabel": "3PM",
    "projection": 2.51,
    "projectedMinutes": 39,
    "side": "under",
    "line": 2.5,
    "bestBook": "betmgm",
    "bestOdds": "+105",
    "ev": 0.1296,
    "evLabel": "+13.0%",
    "pWin": 55,
    "books": [
      {
        "book": "betr_us_dfs",
        "side": "over",
        "line": 2.5,
        "odds": -118,
        "isRemoved": false,
        "ev": -0.1705,
        "pWin": 45
      },
      {
        "book": "betr_us_dfs",
        "side": "under",
        "line": 2.5,
        "odds": -118,
        "isRemoved": false,
        "ev": 0.018,
        "pWin": 55
      },
      {
        "book": "prizepicks",
        "side": "over",
        "line": 2.5,
        "odds": -119,
        "isRemoved": false,
        "ev": -0.1737,
        "pWin": 45
      },
      {
        "book": "prizepicks",
        "side": "under",
        "line": 2.5,
        "odds": -119,
        "isRemoved": false,
        "ev": 0.0141,
        "pWin": 55
      },
      {
        "book": "underdog",
        "side": "over",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": -0.1606,
        "pWin": 45
      },
      {
        "book": "underdog",
        "side": "under",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": 0.0302,
        "pWin": 55
      },
      {
        "book": "pick6",
        "side": "over",
        "line": 2.5,
        "odds": -122,
        "isRemoved": false,
        "ev": -0.183,
        "pWin": 45
      },
      {
        "book": "pick6",
        "side": "under",
        "line": 2.5,
        "odds": -122,
        "isRemoved": false,
        "ev": 0.0027,
        "pWin": 55
      },
      {
        "book": "draftkings",
        "side": "over",
        "line": 2.5,
        "odds": -120,
        "isRemoved": false,
        "ev": -0.1769,
        "pWin": 45
      },
      {
        "book": "draftkings",
        "side": "under",
        "line": 2.5,
        "odds": -110,
        "isRemoved": false,
        "ev": 0.052,
        "pWin": 55
      },
      {
        "book": "novig",
        "side": "over",
        "line": 2.5,
        "odds": -103,
        "isRemoved": false,
        "ev": -0.1151,
        "pWin": 45,
        "betLimit": 205
      },
      {
        "book": "novig",
        "side": "under",
        "line": 2.5,
        "odds": -105,
        "isRemoved": false,
        "ev": 0.0758,
        "pWin": 55,
        "betLimit": 51
      },
      {
        "book": "caesars",
        "side": "over",
        "line": 2.5,
        "odds": -117,
        "isRemoved": false,
        "ev": -0.1673,
        "pWin": 45
      },
      {
        "book": "caesars",
        "side": "under",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": 0.0302,
        "pWin": 55
      },
      {
        "book": "hardrockbet",
        "side": "over",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": -0.1606,
        "pWin": 45
      },
      {
        "book": "hardrockbet",
        "side": "under",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": 0.0302,
        "pWin": 55
      },
      {
        "book": "betparx",
        "side": "over",
        "line": 2.5,
        "odds": -121,
        "isRemoved": false,
        "ev": -0.18,
        "pWin": 45
      },
      {
        "book": "betparx",
        "side": "under",
        "line": 2.5,
        "odds": -110,
        "isRemoved": false,
        "ev": 0.052,
        "pWin": 55
      },
      {
        "book": "betonlineag",
        "side": "over",
        "line": 2.5,
        "odds": -118,
        "isRemoved": false,
        "ev": -0.1705,
        "pWin": 45
      },
      {
        "book": "betonlineag",
        "side": "under",
        "line": 2.5,
        "odds": -110,
        "isRemoved": false,
        "ev": 0.052,
        "pWin": 55
      },
      {
        "book": "fliff",
        "side": "over",
        "line": 2.5,
        "odds": -125,
        "isRemoved": false,
        "ev": -0.1918,
        "pWin": 45
      },
      {
        "book": "fliff",
        "side": "under",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": 0.0302,
        "pWin": 55
      },
      {
        "book": "thescore",
        "side": "over",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": -0.1606,
        "pWin": 45
      },
      {
        "book": "thescore",
        "side": "under",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": 0.0302,
        "pWin": 55
      },
      {
        "book": "betmgm",
        "side": "over",
        "line": 2.5,
        "odds": -140,
        "isRemoved": false,
        "ev": -0.2303,
        "pWin": 45
      },
      {
        "book": "betmgm",
        "side": "under",
        "line": 2.5,
        "odds": 105,
        "isRemoved": false,
        "ev": 0.1296,
        "pWin": 55
      },
      {
        "book": "bovada",
        "side": "over",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": -0.1606,
        "pWin": 45
      },
      {
        "book": "bovada",
        "side": "under",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": 0.0302,
        "pWin": 55
      },
      {
        "book": "prophetx",
        "side": "over",
        "line": 2.5,
        "odds": -108,
        "isRemoved": false,
        "ev": -0.1353,
        "pWin": 45,
        "betLimit": 103
      },
      {
        "book": "prophetx",
        "side": "under",
        "line": 2.5,
        "odds": 101,
        "isRemoved": false,
        "ev": 0.1076,
        "pWin": 55,
        "betLimit": 8
      },
      {
        "book": "betrivers",
        "side": "over",
        "line": 2.5,
        "odds": -122,
        "isRemoved": false,
        "ev": -0.183,
        "pWin": 45
      },
      {
        "book": "betrivers",
        "side": "under",
        "line": 2.5,
        "odds": -112,
        "isRemoved": false,
        "ev": 0.043,
        "pWin": 55
      },
      {
        "book": "fanduel",
        "side": "over",
        "line": 2.5,
        "odds": -111,
        "isRemoved": false,
        "ev": -0.1465,
        "pWin": 45
      },
      {
        "book": "fanduel",
        "side": "under",
        "line": 2.5,
        "odds": -115,
        "isRemoved": false,
        "ev": 0.0302,
        "pWin": 55
      }
    ],
    "bestLines": {
      "over": {
        "book": "novig",
        "side": "over",
        "line": 2.5,
        "odds": -103,
        "isRemoved": false,
        "ev": -0.1151,
        "pWin": 45,
        "betLimit": 205
      },
      "under": {
        "book": "betmgm",
        "side": "under",
        "line": 2.5,
        "odds": 105,
        "isRemoved": false,
        "ev": 0.1296,
        "pWin": 55
      }
    },
    "result": {
      "outcome": "win",
      "actual": 2
    },
    "pmf": [
      0.0957,
      0.2102,
      0.2441,
      0.1991,
      0.1279,
      0.069,
      0.0324,
      0.0136,
      0.0052,
      0.0019,
      0.0006,
      0.0002,
      0.0001
    ],
    "movements": [
      {
        "id": "demo-1631095-Betr Picks-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betr_us_dfs",
        "line": 2.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": -0.1705,
        "under_ev": 0.018,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-PrizePicks-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "prizepicks",
        "line": 2.5,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": -0.1737,
        "under_ev": 0.0141,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-Underdog-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "underdog",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-DraftKings Pick6-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "pick6",
        "line": 2.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": -0.183,
        "under_ev": 0.0027,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-DraftKings-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "draftkings",
        "line": 2.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": -0.1769,
        "under_ev": 0.052,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-Novig-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "novig",
        "line": 2.5,
        "over_odds": -103,
        "under_odds": -105,
        "over_ev": -0.1151,
        "under_ev": 0.0758,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-Caesars-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "caesars",
        "line": 2.5,
        "over_odds": -117,
        "under_odds": -115,
        "over_ev": -0.1673,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-Hard Rock Bet-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "hardrockbet",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-betPARX-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betparx",
        "line": 2.5,
        "over_odds": -121,
        "under_odds": -110,
        "over_ev": -0.18,
        "under_ev": 0.052,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-BetOnline-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betonlineag",
        "line": 2.5,
        "over_odds": -118,
        "under_odds": -110,
        "over_ev": -0.1705,
        "under_ev": 0.052,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-Fliff-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "fliff",
        "line": 2.5,
        "over_odds": -125,
        "under_odds": -115,
        "over_ev": -0.1918,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-theScore Bet-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "thescore",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-BetMGM-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betmgm",
        "line": 2.5,
        "over_odds": -140,
        "under_odds": 105,
        "over_ev": -0.2303,
        "under_ev": 0.1296,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-Bovada-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "bovada",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-ProphetX-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "prophetx",
        "line": 2.5,
        "over_odds": -108,
        "under_odds": 101,
        "over_ev": -0.1353,
        "under_ev": 0.1076,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-BetRivers-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betrivers",
        "line": 2.5,
        "over_odds": -122,
        "under_odds": -112,
        "over_ev": -0.183,
        "under_ev": 0.043,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-FanDuel-0",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "fanduel",
        "line": 2.5,
        "over_odds": -111,
        "under_odds": -115,
        "over_ev": -0.1465,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T00:59:08.731Z"
      },
      {
        "id": "demo-1631095-DraftKings-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "draftkings",
        "line": 2.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": -0.1769,
        "under_ev": 0.052,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-FanDuel-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "fanduel",
        "line": 2.5,
        "over_odds": -111,
        "under_odds": -115,
        "over_ev": -0.1465,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-betPARX-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betparx",
        "line": 2.5,
        "over_odds": -121,
        "under_odds": -110,
        "over_ev": -0.18,
        "under_ev": 0.052,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-BetRivers-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betrivers",
        "line": 2.5,
        "over_odds": -122,
        "under_odds": -112,
        "over_ev": -0.183,
        "under_ev": 0.043,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-BetMGM-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betmgm",
        "line": 2.5,
        "over_odds": -140,
        "under_odds": 105,
        "over_ev": -0.2303,
        "under_ev": 0.1296,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-Caesars-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "caesars",
        "line": 2.5,
        "over_odds": -117,
        "under_odds": -115,
        "over_ev": -0.1673,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-BetOnline-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betonlineag",
        "line": 2.5,
        "over_odds": -118,
        "under_odds": -110,
        "over_ev": -0.1705,
        "under_ev": 0.052,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-theScore Bet-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "thescore",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-Fliff-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "fliff",
        "line": 2.5,
        "over_odds": -125,
        "under_odds": -115,
        "over_ev": -0.1918,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-Bovada-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "bovada",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-Hard Rock Bet-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "hardrockbet",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-ProphetX-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "prophetx",
        "line": 2.5,
        "over_odds": -128,
        "under_odds": 101,
        "over_ev": -0.2003,
        "under_ev": 0.1076,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-PrizePicks-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "prizepicks",
        "line": 2.5,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": -0.1737,
        "under_ev": 0.0141,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-Betr Picks-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betr_us_dfs",
        "line": 2.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": -0.1705,
        "under_ev": 0.018,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-Underdog-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "underdog",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-Novig-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "novig",
        "line": 2.5,
        "over_odds": -103,
        "under_odds": -105,
        "over_ev": -0.1151,
        "under_ev": 0.0758,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-DraftKings Pick6-1",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "pick6",
        "line": 2.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": -0.183,
        "under_ev": 0.0027,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:05:10.813Z"
      },
      {
        "id": "demo-1631095-DraftKings-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "draftkings",
        "line": 2.5,
        "over_odds": -116,
        "under_odds": -114,
        "over_ev": -0.164,
        "under_ev": 0.0344,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-FanDuel-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "fanduel",
        "line": 2.5,
        "over_odds": -111,
        "under_odds": -115,
        "over_ev": -0.1465,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-betPARX-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betparx",
        "line": 2.5,
        "over_odds": -122,
        "under_odds": -109,
        "over_ev": -0.183,
        "under_ev": 0.0566,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-BetRivers-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betrivers",
        "line": 2.5,
        "over_odds": -124,
        "under_odds": -110,
        "over_ev": -0.189,
        "under_ev": 0.052,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-BetMGM-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betmgm",
        "line": 2.5,
        "over_odds": -140,
        "under_odds": 105,
        "over_ev": -0.2303,
        "under_ev": 0.1296,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-Caesars-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "caesars",
        "line": 2.5,
        "over_odds": -117,
        "under_odds": -115,
        "over_ev": -0.1673,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-BetOnline-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betonlineag",
        "line": 2.5,
        "over_odds": -116,
        "under_odds": -111,
        "over_ev": -0.164,
        "under_ev": 0.0474,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-theScore Bet-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "thescore",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-Fliff-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "fliff",
        "line": 2.5,
        "over_odds": -130,
        "under_odds": -115,
        "over_ev": -0.2057,
        "under_ev": 0.0302,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-Bovada-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "bovada",
        "line": 2.5,
        "over_odds": -120,
        "under_odds": -110,
        "over_ev": -0.1769,
        "under_ev": 0.052,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-Hard Rock Bet-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "hardrockbet",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-ProphetX-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "prophetx",
        "line": 2.5,
        "over_odds": -104,
        "under_odds": 101,
        "over_ev": -0.1193,
        "under_ev": 0.1076,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-PrizePicks-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "prizepicks",
        "line": 2.5,
        "over_odds": -119,
        "under_odds": -119,
        "over_ev": -0.1737,
        "under_ev": 0.0141,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-Betr Picks-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "betr_us_dfs",
        "line": 2.5,
        "over_odds": -118,
        "under_odds": -118,
        "over_ev": -0.1705,
        "under_ev": 0.018,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-Underdog-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "underdog",
        "line": 2.5,
        "over_odds": -115,
        "under_odds": -115,
        "over_ev": -0.1606,
        "under_ev": 0.0302,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-Novig-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "novig",
        "line": 2.5,
        "over_odds": -103,
        "under_odds": -106,
        "over_ev": -0.1151,
        "under_ev": 0.0709,
        "has_moved": true,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      },
      {
        "id": "demo-1631095-DraftKings Pick6-2",
        "game_id": "demo-399d2e69",
        "player_name": "Jabari Smith Jr",
        "market": "3pm",
        "bookmaker": "pick6",
        "line": 2.5,
        "over_odds": -122,
        "under_odds": -122,
        "over_ev": -0.183,
        "under_ev": 0.0027,
        "has_moved": false,
        "snapshot_at": "2026-04-27T01:31:10.363Z"
      }
    ]
  }
];
